module.exports = __webpack_public_path__ + "img/图1-5  回归任务.a7d09e86.png";